import { Skeleton } from '@/new/components/shadcn/skeleton';

export function ChronologyTimelineLoader() {
  return (
    <div className="h-full w-full py-0.5">
      <div className="flex h-full flex-col gap-3 pr-1 pl-3">
        {Array.from({ length: 10 }).map((_, index) => (
          <div key={index} className="group relative flex w-full items-center gap-2.5 pl-10">
            <div className="absolute left-0.25 z-10 h-4 w-4 rounded-full border-2 border-teal-500 bg-white" />
            <div className="absolute inset-0 -inset-y-3 w-0.5 translate-x-[8px] bg-gray-200 group-first:top-1/2 group-last:bottom-1/2"></div>

            <div className="w-full rounded-lg border border-gray-100">
              <div className="p-4">
                <div className="flex w-full items-center justify-between gap-2">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-4 w-20" />
                  <Skeleton className="h-4 w-16" />
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <Skeleton className="h-3 w-24" />
                  <Skeleton className="h-3 w-3/4" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
